export default "__VITE_ASSET__CAMI9ZsR__"